






















import { Analysis } from '@/api/analyses/types';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import AgroIcon from '@/components/agroIcons/AgroIcons.vue';
import AnalysisItem from "../analysis-item/AnalysisItem.vue";


@Component({
  name: 'AnalysesListSection',
  components: {
    AgroIcon,
    AnalysisItem,
  }
})
export default class AnalysesListSection extends Vue {
  @Prop(Array)
  private analyses!: Analysis[];

  @Prop(String)
  private analysisType!: string;

  private get analysisTypeLower() {
    return this.analysisType.toLowerCase();
  }

  @Emit('analysis:delete')
  private analysisDeleted(analysis: Analysis) {}

  @Emit('analysis:create')
  private createAnalysis(analysisType: string) {}
}
